export default __webpack_public_path__ + "static/media/profile_active.2e88f343.svg";